// Node Module Imports
import React from 'react'

import htmr from 'htmr'
import PropTypes from 'prop-types'
import showdown from 'showdown'

import shortcodeParser from '../../utils/filters/shortcodeParser'

const converter = new showdown.Converter()

const MarkdownContent = ({ content, className }) => (
  <div className={className}>{content && htmr(converter.makeHtml(shortcodeParser(content)))}</div>
)

MarkdownContent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
}

MarkdownContent.defaultProps = {
  className: '',
}

export default MarkdownContent
